<template>
  <div>
    <div ref="chart" class="chart-container" :style="{height: height || '300px'}" v-if="!empty">
    </div>
    <div class="empty-group">
      <img src="./../../../assets/images/empty.png" v-if="empty"/>
      <div class="gj-empty--description" v-if="empty">{{"暂无数据"}}</div>
    </div>
  </div>
</template>

<script>
import _ from "lodash"

export default {
  name: "chart",
  props: {
    type:{
      type: String,            // 0 bar  1 line  2
      default: "bar"
    },
    height: {
      type: String,
    },
    //echarts参数过多，直接传 option进来解构
    option:{

    },
    empty:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      chart: null,
    }
  },
  watch: {
    option: {
      handler(val, oldVal) {
        if(!_.isEmpty(oldVal) && oldVal !== val && !_.isEqual(oldVal,val)){
          this.setOption();
        }
      }
    },
    empty:{
      handler(val) {
        this.empty = val;
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init(){
      const chartRef = this.$refs.chart;
      if(chartRef){
        this.chart = this.$echarts.init(chartRef);
        this.chart && this.setOption();
      }
    },
    setOption(){
      this.chart.setOption(this.option, true);
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-container {
  width: 100%;
  height: 300px;
}

.empty-group{
  width: 100%;
  text-align: center;

  .gj-empty--description {
    color: #999999;
    font-size: 13px;
    position: relative;
    top: -50px;
  }
}
</style>